// src/tattoo/reactionsRealtime.js
import { supabase } from "./lib/supabaseClient";
import { preloadReactionCounts } from "./reactionsState";

/**
 * Subscribe to realtime reaction changes for a given layer/project id.
 * Whenever a row in `reactions` for this layer changes, we re-preload counts
 * so all hearts stay in sync across tabs/devices.
 */
export function subscribeReactions(layerId) {
  if (!layerId) return () => {};

  const channel = supabase
    .channel(`reactions:${layerId}`)
    .on(
      "postgres_changes",
      {
        event: "*",
        schema: "public",
        table: "reactions",
        filter: `layer_id=eq.${layerId}`,
      },
      async (payload) => {
        try {
          console.log(
            "[reactions] change via realtime",
            layerId,
            payload.eventType,
            payload.new || payload.old
          );
          // Just refresh counts from DB so we don't double-increment locally
          await preloadReactionCounts([layerId]);
        } catch (e) {
          console.warn("[reactions] realtime handler failed:", e);
        }
      }
    )
    .subscribe((status) => {
      console.log("[reactions] realtime status", layerId, status);
    });

  return () => {
    try {
      supabase.removeChannel(channel);
    } catch (e) {
      console.warn("[reactions] unsubscribe failed", e);
    }
  };
}